import { render, staticRenderFns } from "./work-orders-manage.vue?vue&type=template&id=8ebfe85c&scoped=true"
import script from "./work-orders-manage.vue?vue&type=script&lang=js"
export * from "./work-orders-manage.vue?vue&type=script&lang=js"
import style0 from "./work-orders-manage.vue?vue&type=style&index=0&id=8ebfe85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebfe85c",
  null
  
)

export default component.exports